var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0C7.16146 0 0 7.11292 0 15.8915C0 22.9113 4.58333 28.8707 10.9427 30.9709C11.7448 31.1158 12.0365 30.6295 12.0365 30.2053C12.0365 29.8277 12.0208 28.8293 12.0156 27.505C7.5625 28.462 6.625 25.3737 6.625 25.3737C5.89583 23.5373 4.84896 23.0458 4.84896 23.0458C3.39583 22.063 4.95833 22.0837 4.95833 22.0837C6.5625 22.1975 7.40625 23.7183 7.40625 23.7183C8.83333 26.1497 11.151 25.4461 12.0625 25.0426C12.2083 24.0132 12.625 23.3148 13.0781 22.9165C9.52604 22.5182 5.79167 21.1525 5.79167 15.0639C5.79167 13.3257 6.41667 11.9083 7.4375 10.7961C7.27604 10.3978 6.72396 8.77863 7.59375 6.59044C7.59375 6.59044 8.9375 6.16625 11.9948 8.21994C13.2708 7.86818 14.6406 7.6923 16 7.68712C17.3594 7.6923 18.7292 7.86818 20.0052 8.21994C23.0625 6.16625 24.401 6.59044 24.401 6.59044C25.276 8.77863 24.7292 10.3978 24.5625 10.7961C25.5885 11.9083 26.2031 13.3257 26.2031 15.0639C26.2031 21.168 22.4635 22.5078 18.901 22.9062C19.474 23.3924 19.9844 24.365 19.9844 25.8445C19.9844 27.9706 19.9688 29.6828 19.9688 30.2053C19.9688 30.6295 20.2552 31.1261 21.0677 30.9709C27.4219 28.8655 32 22.9113 32 15.8915C32 7.11292 24.8385 0 16 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.19bd3f6441a1bf0d12c9b8402c387f32.svg";
export { ForwardRef as ReactComponent };